export interface Point {
    x: number;
    y: number;
}

// Normalised: width and height are never negative.
export interface Box {
    x: number;
    y: number;
    width: number;
    height: number;
}

interface StrokedShape {
    id: string;
    color: string;
    width: number;
}

export interface PenShape extends StrokedShape {
    kind: 'pen';
    points: readonly Point[];
}

export interface ArrowShape extends StrokedShape {
    kind: 'arrow';
    from: Point;
    to: Point;
}

export interface LineShape extends StrokedShape {
    kind: 'line';
    from: Point;
    to: Point;
}

export interface RectShape extends StrokedShape {
    kind: 'rect';
    box: Box;
}

export interface EllipseShape extends StrokedShape {
    kind: 'ellipse';
    box: Box;
}

export interface TextShape {
    kind: 'text';
    id: string;
    color: string;
    fontSize: number;
    at: Point;
    text: string;
}

export type SegmentShape = ArrowShape | LineShape;
export type BoxShape = RectShape | EllipseShape;

// Every coordinate and size is in image pixels, so marks stay put when the view is resized.
export type MarkupShape = PenShape | SegmentShape | BoxShape | TextShape;

export type DrawTool = 'pen' | 'arrow' | 'line' | 'rect' | 'ellipse';
export type MarkupTool = 'select' | DrawTool | 'text';

export const DRAW_TOOLS: ReadonlySet<MarkupTool> = new Set<MarkupTool>([
    'pen',
    'arrow',
    'line',
    'rect',
    'ellipse'
]);

export function isDrawTool(tool: MarkupTool): tool is DrawTool {
    return DRAW_TOOLS.has(tool);
}

export function isSegmentShape(shape: MarkupShape): shape is SegmentShape {
    return shape.kind === 'arrow' || shape.kind === 'line';
}

export function isBoxShape(shape: MarkupShape): shape is BoxShape {
    return shape.kind === 'rect' || shape.kind === 'ellipse';
}

let shapeSequence = 0;

export function newShapeId(): string {
    shapeSequence += 1;
    return `shape-${shapeSequence}`;
}
